import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { beforeItems, afterItems } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function BeforeAfter() {
  return <section className="w-full bg-canvas px-4 py-16 sm:py-20" data-id="element-80" data-mp="26ll08frx8f20">
      <div className="mx-auto max-w-5xl" data-id="element-81" data-mp="26k044lpyko21">
        <h2 className="text-center font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-82" data-mp="22lkd86qravjc">
          Before vs. <em className="text-brand" data-id="element-83" data-mp="2z9qnpaad0i5j">with</em> Implant Case Decision™
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-84" data-mp="2ubp0cd5whwo9">
          <div className="rounded-3xl border-2 border-refer/25 bg-white p-6 sm:p-7" data-id="element-85" data-mp="2ua45emfocbpv">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-refer px-4 py-1.5 text-sm font-black uppercase tracking-wide text-white" data-id="element-86" data-mp="2qcg8jduf88vc">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-87" data-mp="1ew83n5riolgi" /> Before
            </div>
            <ul className="space-y-3.5" data-id="element-88" data-mp="19vkbuhvgs0l8">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-89" data-mp="175m5b6nk9kf9">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-refer" data-id="element-90" data-mp="1739mkr9zb615">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-91" data-mp="y4xyavwl4kbv" />
                  </span>
                  <span className="text-[16px] leading-snug text-muted" data-id="element-92" data-mp="13396z3b58osi">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-accept bg-white p-6 shadow-[0_20px_40px_-20px_rgba(22,163,74,0.45)] sm:p-7" data-id="element-93" data-mp="ocrxcwocuskj">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-accept px-4 py-1.5 text-sm font-black uppercase tracking-wide text-white" data-id="element-94" data-mp="fegbf7yfoiyf">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="jg1k0h3xqb2t" /> After
            </div>
            <ul className="space-y-3.5" data-id="element-96" data-mp="5gioqow82u7x">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-97" data-mp="ads93q4r8fow">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-100 text-accept" data-id="element-98" data-mp="2c40xwwbw1y8r">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-99" data-mp="27cr73selsova" />
                  </span>
                  <span className="text-[16px] font-medium leading-snug text-ink" data-id="element-100" data-mp="23c7acpxxzn9o">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta label="I want a structured case decision system" data-id="element-101" data-mp="2v23q1jzqgbas" />
      </div>
    </section>;
}